import { OwlOptions } from 'ngx-owl-carousel-o'

export const  defaultOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    navText: ['', ''],
    nav: true,
    margin: 12,
    autoWidth: true,
    rtl: localStorage.getItem('language') == 'ar' ? true : false,

}

export const subCatOptions = {
    ...defaultOptions,
    responsive: {
        0: {
            items: 2,
        },
        400: {
            items: 4,
        },
        740: {
            items: 6,
        },
        940: {
            items: 9,
        },
        1500: {
            items: 9,
        },
    },
}

export const catOptions : OwlOptions = {
    ...defaultOptions,
    responsive: {
        0: {
            items: 2,
        },
        400: {
            items: 4,
        },
        740: {
            items: 5,
        },
        940: {
            items: 6,
        },
        2000: {
            items: 6,
        },
    },
    navText: [
        '<img src="/assets/images/arrow-gradient.svg" class="rotate-180 inline-block mt-[10px]" />',
        '<img src="/assets/images/arrow-gradient.svg" class="inline-block mt-[10px]" />',
    ],
}
